import React from 'react';

const Logo = ({ size = 'default', variant = 'full' }) => {
    const sizeClasses = {
        small: { width: '120px', fontSize: '1.2rem', logoHeight: '32px' },
        default: { width: '180px', fontSize: '1.5rem', logoHeight: '40px' },
        large: { width: '240px', fontSize: '2rem', logoHeight: '48px' }
    };

    const logoStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        ...sizeClasses[size]
    };

    const imageStyle = {
        height: sizeClasses[size].logoHeight,
        width: 'auto',
        objectFit: 'contain'
    };

    const textStyle = {
        fontWeight: 700,
        fontSize: sizeClasses[size].fontSize,
        background: 'linear-gradient(135deg, var(--primary-green) 0%, var(--accent-green-bright) 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        letterSpacing: '-0.02em'
    };

    return (
        <div style={logoStyle}>
            {/* Company Logo Image */}
            <img
                src="/logo_transparent_background.png"
                alt="VissdaTech Logo"
                style={imageStyle}
            />

            {/* {variant === 'full' && (
                <span style={textStyle}>
                    Vissda<span style={{ color: 'var(--primary-black)' }}>Tech</span>
                </span>
            )} */}
        </div>
    );
};

export default Logo;